import { NgModule } from '@angular/core';

import { LotBiddingModalGuideService } from './services/lot-bidding-modal-guide.service';

@NgModule({
  providers: [LotBiddingModalGuideService],
})
export class LotBiddingModalGuideModule {}
